import DOMPurify from "dompurify";

export const sanitizeHtml = (dirty: string | null | undefined): string => {
  if (!dirty) {
    return "";
  }

  if (typeof window === "undefined") {
    return "";
  }

  return DOMPurify.sanitize(dirty, { USE_PROFILES: { html: true } });
};
